'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMedical(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M9.355 4.72V3.46h-2.71V4.72h2.71zM9.16 2.3c.75 0 1.355.594 1.355 1.334v.948h2.13c.75 0 1.354.593 1.354 1.334v6.275a1.34 1.34 0 01-1.355 1.335h-9.29A1.34 1.34 0 012 12.19l.006-6.275c0-.741.599-1.334 1.349-1.334h2.129v-.948c0-.74.604-1.334 1.355-1.334H9.16zM8 7.139a.645.645 0 00-.638.55l-.007.095v.645H6.71a.645.645 0 00-.096 1.283l.096.007h.645v.646a.645.645 0 001.283.095l.007-.095v-.646h.645a.645.645 0 00.096-1.283l-.096-.007h-.645v-.645A.645.645 0 008 7.139z", fill: "currentColor" }))));
}

module.exports = SvgMedical;
//# sourceMappingURL=Medical.js.map
